import { type FullPageEditorPresetAPI } from '@confluence/full-page-editor-store';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

type SendContentFeaturesProps = {
	contentId: string;
	editorApi?: FullPageEditorPresetAPI | null;
	isInEditor?: boolean;
	isAbbreviatedReadTime?: boolean;
	isDetailsPanel?: boolean;
	showWordCount?: boolean;
};

export const ReadTime: LoadableType<SendContentFeaturesProps> =
	LoadableAfterPaint<SendContentFeaturesProps>({
		loader: async () =>
			(await import(/* webpackChunkName: "loadable-ReadTime" */ '../src/ReadTime.tsx')).ReadTime,
	});
